var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Bildfeld")])]),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-btn',{staticClass:"mx-1",attrs:{"fab":"","dark":"","x-small":"","color":"secondary"},on:{"click":function($event){return _vm.$emit('delete')}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-trash-can")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }